// extracted by mini-css-extract-plugin
module.exports = {"facetDisplayRoot":"Checkbox_facetDisplayRoot__bcanF"};